import styled from "styled-components";
import Button from "./General/Button";
import { useRouter } from "next/router";
import WhatsAppModal from "./WhatsAppModal";
import { useState } from "react";

function WhatsAppButton() {
	const router = useRouter();
	const [showModal, setShowModal] = useState(false);

	return (
		<>
			{/* <StyledAnchor href="https://api.whatsapp.com/send?phone=918655735634" target="_blank" className="block cursor-pointer"> */}
				<Button 
					destinationEvent = "WhatsApp Modal Open" 
					styles = "flex bg-theme-orange rounded-[4px] w-[190px] h-[52px] cursor-pointer z-[100]"
					onClick = {() => setShowModal(true)}
				>
					<img className="w-[24px] mr-[10px]" src="/WhatsAppIcon.svg" alt="WA" />
					<p className="text-[18px] font-[500] text-white"> Get Best Quote </p>
				</Button>
			{/* </StyledAnchor> */}

			<WhatsAppModal show = {showModal} onClose = {() => setShowModal(false)} />
		</>
	)
}

export default WhatsAppButton